export default __webpack_public_path__ + "static/media/comment-white.70bdf9a0.svg";